import React, { createContext, useState, useEffect, useContext } from "react";
import { auth } from "../firebaseConfigurations/config";
import { onAuthStateChanged } from "firebase/auth";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isSubscribed, setIsSubscribed] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);
      if (currentUser) {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_URL}/subscription/check-status`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                email: currentUser.email,
                user_id: currentUser.uid,
              }),
            }
          );

          const data = await response.json();
          setIsSubscribed(data.active || false);
        } catch (error) {
          setIsSubscribed(false);
          console.error("Failed to fetch subscription status:", error);
        }
      } else {
        setIsSubscribed(false);
      }
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, isSubscribed }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
